import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { getPointForRef, toNumber } from "../../components/Common";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import { updateLayout2D } from "../../redux_store/appStateHelper";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import BSL_Button from "../../components/BSL_Button";
import { updateAreaSpecificationRoofSheet } from "../../redux_store/jobState";
import { trimEnd } from "lodash";

const styles = (theme) => ({
    qq2dCanvasContainer: {
        zIndex: 0,
        display: "block",
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: "rgba(255, 255, 255, 255)",
        width: "100%",
        height: "100%",
        color: "#000",
        transition: "visibility 0.3s, opacity 0.3s linear",
        textAlign: "left",
    },

    qq2dCanvas: {
        width: "100vw",
        height: "100vh",
    },
    snackbar: {
        zIndex: "1300",
    },
    typography: {
        padding: "20px",
    },
    menu_item: {
        fontFamily: theme.typography.fontFamily,
        fontSize: "16px",
        "&:hover": {
            background: "#b9c9e6",
        },
    },
});

const designerStyles = makeStyles({
    iconRoot: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
    },
    paper: {
        padding: "125px 20px 20px 20px",
        minWidth: "500px",
        maxWidth: "25%",
        backgroundColor: "#EDF0F3",
    },
    mini_button: {
        position: "absolute",
        right: "10px",
        lineHeight: 1.25,
        paddingTop: "5px",
    },
});

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

export default function SpecSetRoofLayingOffset(props) {
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const { areaIndex } = props;
    const SELECTED_ELEMENT = app.designer.designer2D[APP.SELECTED_POINT];

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [waitingForPoints, setWaitingForPoints] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const [firstItem, setFirstItem] = React.useState(false);
    const [lastSVGLoaded, setLastSVGLoaded] = React.useState(window.last_svg_load_attempt);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECTED_ELEMENT && waitingForPoints) {
            dispatch(APP.update2DDesigner(APP.SELECT_POINT, false));
            if (window.roof_laying_offset_selected_point) {
                let offset = window.roof_laying_offset_selected_point.x;
                if (
                    AreaSpecifications[areaIndex].SHAPE.SheetDirection === "Left" ||
                    AreaSpecifications[areaIndex].SHAPE.SheetDirection === "Right"
                ) {
                    offset = window.roof_laying_offset_selected_point.y;
                }

                let error = dispatch(updateAreaSpecificationRoofSheet(areaIndex, null, "SheetLayingOffset", offset));
                if (error?.error) {
                    dispatch(APP.showDialogData(error));
                }
            }
        }
    }, [SELECTED_ELEMENT]);

    if (loaded && window.roof_laying_offset_waiting_for_points && window.last_svg_load_attempt != lastSVGLoaded) {
        setLastSVGLoaded(window.last_svg_load_attempt);
        reFormatSVG(0);
    }

    function reFormatSVG(count) {
        if (count > 20) {
            FormatSVGForRoofLayingOffset(props.pop_item);
            return;
        }
        setTimeout(function () {
            if (firstItem == window.paper.project.activeLayer.children[0]) {
                reFormatSVG(count + 1);
            } else {
                FormatSVGForRoofLayingOffset(props.pop_item);
            }
        }, 100);
    }

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECT_POINT === false) {
            setWaitingForPoints(false);
            setLoaded(false);
            dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
            onClose();
        }
    }, [SELECT_POINT]);

    const SetChildrenGrey = (item) => {
        if (!item?.children) return;
        if (item.sheet_laying_point) return;
        item.children.forEach(function (item) {
            if (window.last_pop_item === item) {
                return;
            }
            if (item.fillColor) item.fillColor = "#dddddd";
            if (item.strokeColor) item.strokeColor = "#bbbbbb";
            item.pickable = false;
            if (item.children) {
                SetChildrenGrey(item);
            }
        });
    };

    function FormatSVGForRoofLayingOffset(areaIndex) {
        let items = GetItems();
        setFirstItem(items?.[0]);
        if (items?.[0]?.children) {
            SetChildrenGrey(items?.[0]);
        }

        window.roof_laying_offset_sheet_outlines = GetItems({ is_sheet_outline: true, areaIndex: areaIndex });
        window.roof_laying_offset_sheet_outlines.forEach(function (sheet_outline) {
            sheet_outline.strokeColor = "#4444EE";
            sheet_outline.strokeWidth = 36;
            window.paper.project.activeLayer.addChild(sheet_outline);
            sheet_outline.bringToFront();
            sheet_outline.pickable = true;
        });
        GetItems({ class: window.paper.TextItem }).forEach(function (item) {
            item.sendToBack();
        });

        GetItems({ sheet_laying_point: true }).forEach(function (sheet_laying_point) {
            sheet_laying_point.bringToFront();
            sheet_laying_point.strokeWidth = 24;
            sheet_laying_point.strokeColor = "#eead44ff";
            sheet_laying_point.fillColor = "#eebe44ff";
        });
    }

    function onMouseMoveRoofLayingOffset(event) {
        if (
            window.roof_laying_offset_paper_setup &&
            window.roof_laying_offset_sheet_outlines &&
            window.roof_laying_offset_waiting_for_points &&
            !window.dragging
        ) {
            let minDist = Infinity;
            let closestSegment = null;
            let closestPath = null;
            window.roof_laying_offset_sheet_outlines.forEach(function (path) {
                for (let segment of path.segments) {
                    const dist = event.point.getDistance(segment.point);
                    if (dist < minDist) {
                        closestPath = path;
                        minDist = dist;
                        closestSegment = segment;
                    }
                }
            });

            if (closestSegment) {
                const size = 200;
                const topLeft = closestSegment.point.subtract(size / 2);
                window.roof_laying_offset_selected_outline = closestPath;
                window.roof_laying_offset_selected_point = getPointForRef(
                    closestSegment._index == 0 ? closestPath.p1 : closestPath.p2
                );

                // Remove previous highlight
                if (window.paper_settings.highlightRect) {
                    window.paper_settings.highlightRect.remove();
                }

                // Draw new highlight
                window.paper_settings.highlightRect = new window.paper.Path.Rectangle({
                    point: topLeft,
                    size: [size, size],
                    strokeColor: "red",
                    fillColor: "rgba(255,0,0,0.1)",
                    strokeWidth: 8,
                });
            } else {
                if (window.paper_settings.highlightRect) {
                    window.paper_settings.highlightRect.remove();
                }
            }
        }
    }

    const setupPaper = () => {
        if (!window.roof_laying_offset_paper_setup) {
            window.paper.view.on("mousemove", onMouseMoveRoofLayingOffset);
            window.roof_laying_offset_paper_setup = true;
        }
    };

    const pickOffset = () => {
        setWaitingForPoints(true);
        window.roof_laying_offset_waiting_for_points = true;
        ClearScratch();
        setupPaper();

        if (window.svg) {
            FormatSVGForRoofLayingOffset(props.areaIndex);
        }

        dispatch(
            APP.update2DDesigner(
                APP.SELECT_POINT_NOTE,
                <>
                    Select an edge to lay roofsheets from. <br />
                    *Right click or press 'ESC' to finish.
                </>
            )
        );
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "SelectElement"));
        setLoaded(true);
    };

    const onClose = () => {
        ClearScratch();
        setLoaded(false);
        setWaitingForPoints(false);
        window.roof_laying_offset_waiting_for_points = false;

        dispatch(updateLayout2D());
        if (props.onClose) {
            props.onClose();
            return;
        }
    };

    return (
        <>
            <BSL_Button
                style={{ marginLeft: "8px", marginTop: "10px", alignSelf: "center", width: "20px" }}
                onClick={pickOffset}
                disabled={app.designer.threeDMode && !app.designer.threeDMiniMode}
                disabledTooltip="Cannot set offset point in 3D Model View"
            >
                <ControlPointIcon style={{ width: "16px", height: "16px" }} />
            </BSL_Button>
        </>
    );
}
